import React from 'react';
import { Snackbar, Alert } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const Toast = ({
    open,
    message,
    severity = 'success',
    onClose,
    autoHideDuration = 3000,
    anchorOrigin = { vertical: 'top', horizontal: 'center' },
    sx = {},
}) => {
    const theme = useTheme();

    return (
        <Snackbar
            open={open}
            autoHideDuration={autoHideDuration}
            onClose={onClose}
            anchorOrigin={anchorOrigin}
            sx={{
                mt: { xs: '60px', sm: '20px' },
                ...sx,
            }}
        >
            <Alert
                onClose={onClose}
                severity={severity}
                sx={{
                    width: '100%',
                    borderRadius: '8px',
                    fontSize: '14px',
                    fontWeight: 500,
                    boxShadow: theme.palette.shadows?.custom?.tooltip || '0px 4px 12px rgba(0, 0, 0, 0.15)',
                    backgroundColor: severity === 'success'
                        ? theme.palette.figma?.popupBG || theme.palette.background.paper
                        : severity === 'error'
                            ? theme.palette.figma?.semantic?.error?.main || theme.palette.error.main
                            : severity === 'warning'
                                ? theme.palette.figma?.semantic?.warning?.main || theme.palette.warning.main
                                : theme.palette.figma?.semantic?.info?.main || theme.palette.info.main,
                    color: theme.palette.figma?.white?.[100] || '#FFFFFF',
                    '& .MuiAlert-icon': {
                        color: theme.palette.figma?.white?.[100] || '#FFFFFF',
                    },
                    '& .MuiAlert-action': {
                        color: theme.palette.figma?.white?.[100] || '#FFFFFF',
                    },
                }}
            >
                {message}
            </Alert>
        </Snackbar>
    );
};

export default Toast;






